
import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { Button } from 'react-bootstrap';
import 'react-table/react-table.css';
import moment from 'moment';
import { OpportunityView } from '../';
import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';

const DateCell = props => (props.value? moment(props.value).format('MMM DD, YYYY hh:mm:ss'): '');
const MoneyCell = ({value}) => <span className='pull-right'>{value ? `$ ${value.toLocaleString()}` : '(none)'}</span>;
const NumberCell = ({value}) => <span className='pull-right'>{value ? `${value.toLocaleString()}` : '(none)'}</span>;

class OpportunitiesTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filter_data : [],
      sort_data : '',
      start_date : moment().subtract(29, 'days'),
      end_date : moment(),
      estimate_min : '',
      estimate_max : '',
      price_min : '',
      price_max : ''
    }

    this.filter_update_valid = true;
    this.filter_timer_id = null;

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handleSortingChange = this.handleSortingChange.bind(this);
    this.handleFilterChanged = this.handleFilterChanged.bind(this);
    this.filterRender = this.filterRender.bind(this);
    this.dateFilterRender = this.dateFilterRender.bind(this);
    this.minMaxFilterRender = this.minMaxFilterRender.bind(this);
    this.handleMinMaxChange = this.handleMinMaxChange.bind(this);
    this.handleApplyDate = this.handleApplyDate.bind(this);
    this.handleClearDate = this.handleClearDate.bind(this);
    this.handleClearMinMax = this.handleClearMinMax.bind(this);
    this.refresh = this.refresh.bind(this);
  }
  componentDidMount() {
    this.props.fetchJobs();
    this.props.fetchFields('Job');
    this.props.fetchFields('Client');
  }
  handlePageChange(offset) {
    this.props.fetchJobs({ offset });
  }
  handlePageSizeChange(size, offset) {
    this.props.fetchJobs({ size, offset });
  }
  refresh() {
    this.props.fetchJobs();
  }
  handleSortingChange(column) {
    let found = false;
    let sort = this.props.sort.split(' ').map(item => {
      let asc = item[0] != '-';
      const id = !asc? item.slice(1,item.length) : item;
      if(column.id == id) {
        asc = !asc;
        found = true;
      }
      return { id, asc };
    });
    if(!found) {
      sort = [{ id: column.id, asc: false }];
    }

    this.setState({sort_data : sort.reduce((acc, item) => `${acc ? acc + ' ': acc}${!item.asc ? '-' : ''}${item.id}`, '')});
    this.props.fetchJobs({
      sort: sort.reduce((acc, item) => `${acc ? acc + ' ': acc}${!item.asc ? '-' : ''}${item.id}`, ''),
      filters : this.state.filter_data
    });
  }
  handleFilterChanged(column, input) {
    const { id } = column;
    const { filter_data } = this.state;

    let updated_filter_data;
    if(input == '') {
      updated_filter_data = filter_data.filter(e => e.type != id);
    }
    else if(filter_data.find(e => e.type == id)) {
      updated_filter_data = filter_data.map(e => e.type == id ? {type : id, value : input}  : e);
    }
    else {
      updated_filter_data = [...filter_data, {type : id, value : input}];
    }

    this.setState({filter_data : updated_filter_data}, () => {
      if(this.filter_update_valid) {
        this.filter_update_valid = false;
        this.props.fetchJobs({
          sort: this.state.sort_data && this.state.sort_data != '' ? this.state.sort_data : null,
          filters : this.state.filter_data
        });
      }
      else {
        if(this.filter_timer_id) {
          clearTimeout(this.filter_timer_id);
        }

        this.filter_timer_id = setTimeout(() => {
          this.props.fetchJobs({
            sort: this.state.sort_data && this.state.sort_data != '' ? this.state.sort_data : null,
            filters : this.state.filter_data
          });
        }, 400);
      }
    })
  }
  handleApplyDate({startDate, endDate}) {
    this.setState({
      start_date :startDate,
      end_date :endDate
    });

    this.handleFilterChanged(
      {id : 'created_timestamp'},
      {start_date : startDate.toDate(), end_date : endDate.toDate()}
    )
  }
  handleClearDate() {
    this.setState({
      start_date : moment().subtract(29, 'days'),
      end_date : moment()
    });

    this.handleFilterChanged({id : 'created_timestamp'}, '');
  }
  handleClearMinMax(prop) {
    this.setState({
      [`${prop}_min`] : '',
      [`${prop}_max`] : ''
    })
    this.handleFilterChanged({id : prop}, '');
  }
  filterRender({filter, onFilterChange}) {
    return <input onChange={(e) => onFilterChange(e.target.value)} />
  }
  dateFilterRender() {
    const start = this.state.start_date.format('MM-DD-YYYY');
    const end = this.state.end_date.format('MM-DD-YYYY');
    const label = start == end ? start : `${start} - ${end}`;
    return (
      <div className='input-group'>
        <DatetimeRangePicker
          startDate={this.state.start_date}
          endDate={this.state.end_date}
          onApply={(e, picker) => {this.handleApplyDate(picker)}}
          >
          <input type='text' className='form-control' value={label}/>
        </DatetimeRangePicker>
        <span className='input-group-btn'>
          <Button
            className='default date-range-clear'
            onClick={this.handleClearDate}
            >
            <i className='fa fa-times'/>
          </Button>
        </span>
      </div>
    )
  }
  minMaxFilterRender(prop) {
    return (
      <div className='row'>
        <div className='col-md-12 col-xs-12'>
          <div className='col-md-4 col-xs-4 opportunities-min-max-col'>
            <input
              value={prop == 'price' ? this.state.price_min : this.state.estimate_min}
              onChange={(e) => {this.handleMinMaxChange(e, prop, 'min')}}
              placeholder='Min'
              className='form-control'
            />
          </div>
          <div className='col-md-4 col-xs-4 opportunities-min-max-col'>
            <input
              value={prop == 'price' ? this.state.price_max : this.state.estimate_max}
              onChange={(e) => {this.handleMinMaxChange(e, prop, 'max')}}
              placeholder='Max'
              className='form-control'
            />
          </div>
          <div className='col-md-2 col-xs-2 opportunities-min-max-col'>
            <div
              className='btn btn-default'
              onClick={() => {this.handleClearMinMax(prop)}}
              >
              <i className='fa fa-times' />
            </div>
          </div>
        </div>
      </div>
    )
  }
  handleMinMaxChange(e, prop, type) {
    const opposite_val = this.state[`${prop}_${type == 'min' ? 'max' : 'min'}`];
    this.setState({[`${prop}_${type}`] : e.target.value}, () => {
      if(opposite_val && opposite_val != '') {
        this.handleFilterChanged({id : prop}, {min : this.state[`${prop}_min`], max : this.state[`${prop}_max`]});
      }
    });
  }

  render() {
    const sort = this.props.sort.split(' ').map(item => {
      const desc = item[0] == '-';
      const id = desc? item.slice(1,item.length) : item;
      return { id, desc };
    });

    return (
      <ReactTable
        manual
        showFilters
        onFilteringChange={this.handleFilterChanged}
        columns={[{
          header: 'Opportunity',
          columns: [{
            header: 'Number',
            accessor: 'number',
            render: ({value, row}) => <Button onClick={e => this.props.push(`/opportunities-table/${row._id}`)} block># {value != null ? value : ''}</Button>,
            filterRender : this.filterRender
          }, {
            header: 'Estimate',
            accessor: 'estimate',
            render: MoneyCell,
            filterRender : () => this.minMaxFilterRender('estimate')
          }, {
            header: 'Price',
            accessor: 'price',
            render: MoneyCell,
            filterRender : () => this.minMaxFilterRender('price')
          }, {
            header: 'Assigned To',
            accessor: 'assigned_to',
            render: ({value}) => <span className="text-primary"><i className="fa fa-user"></i> {value ? `${value.name.first} ${value.name.last} (${value.role})`: '(none)' }</span>,
            filterRender : this.filterRender
          }, {
            header: 'Created',
            accessor: 'created_timestamp',
            render: DateCell,
            filterRender : this.dateFilterRender
          }, {
            header: 'Category',
            accessor: 'category',
            filterRender : this.filterRender
          }, {
            header: 'Work Type',
            accessor: 'work_type',
            render: ({value}) => value.join(', '),
            filterRender : this.filterRender
          }, {
            header: 'Milestone',
            accessor: 'milestone',
            render: ({value}) => <span className="text-center label text-bold label-primary">{value}</span>,
            filterRender : this.filterRender
          }]
        },{
          header: 'Client',
          columns: [{
            header: 'Name',
            accessor: 'client.name',
            render: (data) => <Button onClick={e => this.props.push(`/client/${data.row.client._id}`)} block><i className="fa fa-user"></i> {data.value}</Button>,
            filterRender : this.filterRender
          }, {
            header: 'Street',
            accessor: 'client.address.street',
            filterRender : this.filterRender
          }, {
            header: 'City',
            accessor: 'client.address.city',
            filterRender : this.filterRender
          }, {
            header: 'State',
            accessor: 'client.address.state',
            filterRender : this.filterRender
          }, {
            header: 'Zip',
            accessor: 'client.address.zip',
            render: NumberCell,
            filterRender : this.filterRender
          }, {
            header: 'Country',
            accessor: 'client.address.country',
            filterRender : this.filterRender
          }]
        }]}
        data={this.props.data}
        page={this.props.offset}
        pageSize={this.props.size}
        sorting={sort}
        pages={Math.ceil(this.props.total / this.props.size)}
        loading={this.props.downloading_jobs}
        onPageChange={this.handlePageChange}
        onPageSizeChange={this.handlePageSizeChange}
        onSortingChange={this.handleSortingChange}
      />
    );
  }
}

export default connect(({jobs, fields}) => ({...jobs, fields,  data: jobs.downloaded_jobs.map(({job}) => ({...job}))}), Actions, null, {withRef: true})(OpportunitiesTable);



// WEBPACK FOOTER //
// ./src/browser/components/opportunities/opportunities-table.js